"use strict";

import React from "react";
import Head from "next/head";
import { I18nextProvider } from "react-i18next";
import { startI18n, getTranslation } from "../src/helpers/i18n";
import MyHead from "../src/components/MyHead";
import Footer from "../src/components/Footer";

export default class Error extends React.Component {
  static async getInitialProps({ req = {}, res, err }) {
    const statusCode = res ? res.statusCode : err ? err.statusCode : null;

    const { locale = process.env.DEFAULT_LANG } = req;
    const translations = await getTranslation(locale);

    return { statusCode, locale, translations };
  }

  constructor(props) {
    super(props);
    this.i18n = startI18n(props.translations, props.locale);
  }

  render() {
    const { locale } = this.props;

    return (
      <I18nextProvider i18n={this.i18n}>
        <div>
          <MyHead locale={locale} />
          <Head>
            <title>Ops!</title>
          </Head>

          <section className="container" id="errorPage">
            <div className="col-md-12">
              <img
                src="/static/image/Icona+Naming_NeerU_Blue.svg"
                alt=""
                className="u-center-horizontal"
              />
              <h1 className="text-center u-bold">OPS!</h1>
              {(this.props.statusCode === 404 && (
                <p className="text-center errorPage__h1--color-black">
                  {this.i18n.t("NOT_FOUND")}
                </p>
              )) || (
                <p className="text-center errorPage__h1--color-black">
                  {this.i18n.t("ERROR")}
                </p>
              )}
              <a href={`/${this.props.locale}/login`}>
                <button className="btn btn-neeru u-center-horizontal">
                  {this.i18n.t("BACK_TO_HOME")}
                </button>
              </a>
            </div>
          </section>
          <Footer fullWidth />
        </div>
      </I18nextProvider>
    );
  }
}



// WEBPACK FOOTER //
// pages/_error.js